/**
 * @file JS - Class - Gis.js
 * @author Adam Lemire
 * @since 2019/06/08
 * @version 1.0
 * @summary Dernières modifications : 2019/11/28
 */

import { gisSettings } from '../gisSettings.js';
import { Evenements } from '../events/Evenements.js';
import Project from './Project.js'; // eslint-disable-line no-unused-vars
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import fetch from 'isomorphic-fetch';

const URL_GEOSERVER_CAPABILITIES = gisSettings.geoserver.workspace.cieq.urlCapabilities;

/** Classe Gis représente le SIG en tant que tel. C'est la classe principale à appeler dans le main.js (par le controller GisController) */
export default class Gis {
  /**
   * @example
   * this._gis = new Gis(version);
   * @param { string } version - Gis version
   */
  constructor (version) {
    /** @type { string } */
    this._version = version;
    /** @type { Project } */
    this._projet = null;
    this._listeCouchesWeb = this.obtenirListeCouchesServeur();
  }

  get version () { return this._version; }

  get projet () { return this._projet; }

  /** @param { Project } projet */
  set projet (projet) {
    this._projet = projet;
  }

  /**
   * @returns { WMTSCapabitilies }
   * @todo éventuellement diviser par dossier selon nom de la couche, ou selon schéma
   */
  async obtenirListeCouchesServeur () {
    try {
      const parser = new WMTSCapabilities();
      const resp = await fetch(URL_GEOSERVER_CAPABILITIES);
      const responseText = await resp.text();
      const capabilities = await parser.read(responseText);
      const webLayersArray = capabilities.Contents.Layer;
      const listeCouchesServeurFiltree = this._enleverCouchesBasseResolutionDeCouchesServeur(webLayersArray);
      const listeCoucheServeurTriee = listeCouchesServeurFiltree.sort((a, b) => (a.Title > b.Title) ? 1 : -1);

      this._notifierListeCouchesServeurPrete(listeCoucheServeurTriee);
      return listeCoucheServeurTriee;
    } catch (err) {
      Evenements.erreurObtenirListeCouchesServeur.notify();
    }
  }

  _enleverCouchesBasseResolutionDeCouchesServeur (listeCouchesServeur) {
    const listeCouchesFiltree = [];
    listeCouchesServeur.forEach(function (element, index) {
      if (!element.Title.includes('_br')) listeCouchesFiltree.push(element);
    });

    return listeCouchesFiltree;
  }

  /**
   * @todo à faire
   */
  afficherAide () {
    console.log('afficherAide');
  }

  /*
   * Listeners pour GisController
   */

  /** @param { string[] } listener */
  écouterListeCouchesServeurPrete (listener) {
    this._notifierListeCouchesServeurPrete = listener;
  }

  /** @param { string[] } webLayersArray */
  _notifierListeCouchesServeurPrete (webLayersArray) {}
}
